<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form pt-1"
    @submit.prevent="addItem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="6"
        md="6"
        sm="12"
        class="pb-0"
      >
        <v-text-field
          v-model="form.nome"
          placeholder="Digite o nome"
          label="Nome *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="3"
        sm="12"
        class="pb-0"
      >
        <v-text-field
          v-model="form.cpf"
          v-mask="'###.###.###-##'"
          placeholder="Digite o cpf"
          label="CPF *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="3"
        sm="12"
        class="pb-0"
      >
        <v-text-field
          v-model="form.celular"
          v-mask="'(##)#####-####'"
          placeholder="Digite o celular"
          label="Celular *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="5"
        md="5"
        sm="12"
        class="pb-0 pt-0"
      >
        <v-text-field
          v-model="form.telefone"
          v-mask="'(##)####-####'"
          placeholder="Digite o telefone"
          label="Telefone"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="5"
        md="5"
        sm="12"
        class="pb-0 pt-0"
      >
        <v-text-field
          v-model="form.email"
          placeholder="Digite o email"
          label="E-mail*"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="2"
        md="2"
        sm="12"
        class="pb-0 pt-0"
      >
        <v-btn
          depressed
          type="submit"
          color="success"
          block
          outlined
        >
          <v-icon
            class="icon"
          >
            add
          </v-icon>
          Adicionar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ContactForm',

  props: {
    value: {
      type: Array,
      default: ()=>([]),
    },
  },

  data: () => ({
    form: {
      nome: "",
      cpf: "",
      email: "",
      celular: "",
      telefone: ""
    },

    items: [],

    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    }
  }),

  methods: {
    addItem() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        const newItems = [this.form]

        const hasInItems = this.items.filter(c => c.email === this.form.email)

        if (hasInItems.length > 0) {
          const indexOf = this.items.indexOf(hasInItems[0])

          if (indexOf > -1) {
            this.items[indexOf] = this.form
          }
        }
        else {
          this.items = [...this.items, ...newItems]
        }

        this.resetForm()
        this.$emit('input', [...this.value, ...this.items]);
      }
    },

    resetForm() {
      this.form = {
        nome: "",
        cpf: "",
        email: "",
        celular: "",
        telefone: ""
      }

      this.$refs.form.reset()
    },
  },
};
</script>


